import activityFeed from '../locales/en/activity-feed.json' with { type: 'json' };
import catalog from '../locales/en/catalog.json' with { type: 'json' };
import common from '../locales/en/common.json' with { type: 'json' };
import companyAddressTable from '../locales/en/company-address-table.json' with { type: 'json' };
import companyContactTable from '../locales/en/company-contact-table.json' with { type: 'json' };
import createCustomerAddressForm from '../locales/en/create-customer-address-form.json' with { type: 'json' };
import createCustomerContactForm from '../locales/en/create-customer-contact-form.json' with { type: 'json' };
import customerDetail from '../locales/en/customer-detail.json' with { type: 'json' };
import customersList from '../locales/en/customers-list.json' with { type: 'json' };
import dashboard from '../locales/en/dashboard.json' with { type: 'json' };
import events from '../locales/en/events.json' with { type: 'json' };
import explorer from '../locales/en/explorer.json' with { type: 'json' };
import filters from '../locales/en/filters.json' with { type: 'json' };
import genericList from '../locales/en/generic-list.json' with { type: 'json' };
import insightsTriage from '../locales/en/insights-triage.json' with { type: 'json' };
import insights from '../locales/en/insights.json' with { type: 'json' };
import lineItemTable from '../locales/en/line-item-table.json' with { type: 'json' };
import notes from '../locales/en/notes.json' with { type: 'json' };
import opportunities from '../locales/en/opportunities.json' with { type: 'json' };
import orderLineStatus from '../locales/en/order-line-status.json' with { type: 'json' };
import orderStatus from '../locales/en/order-status.json' with { type: 'json' };
import presetDatePicker from '../locales/en/preset-date-picker.json' with { type: 'json' };
import productDetails from '../locales/en/product-details.json' with { type: 'json' };
import quotesOrdersActions from '../locales/en/quotes-orders-actions.json' with { type: 'json' };
import quotesOrdersHeader from '../locales/en/quotes-orders-header.json' with { type: 'json' };
import quotesOrdersLineActions from '../locales/en/quotes-orders-line-actions.json' with { type: 'json' };
import quotesOrdersLineItems from '../locales/en/quotes-orders-line-items.json' with { type: 'json' };
import quotesOrdersList from '../locales/en/quotes-orders-list.json' with { type: 'json' };
import quotes from '../locales/en/quotes.json' with { type: 'json' };
import reorders from '../locales/en/reorders.json' with { type: 'json' };
import salesDraft from '../locales/en/sales-draft.json' with { type: 'json' };
import salesHistory from '../locales/en/sales-history.json' with { type: 'json' };
import tableCommon from '../locales/en/table-common.json' with { type: 'json' };
import tableProductAvailibity from '../locales/en/table-product-availibity.json' with { type: 'json' };
import tableProductSalesHistory from '../locales/en/table-product-sales-history.json' with { type: 'json' };
import tapiIntegration from '../locales/en/tapi-integration.json' with { type: 'json' };
import tasks from '../locales/en/tasks.json' with { type: 'json' };
import team from '../locales/en/team.json' with { type: 'json' };
import toasts from '../locales/en/toasts.json' with { type: 'json' };
import transactionDetails from '../locales/en/transaction-details.json' with { type: 'json' };

export const enTranslations = {
    'activity-feed': activityFeed,
    catalog: catalog,
    common: common,
    'company-address-table': companyAddressTable,
    'company-contact-table': companyContactTable,
    'create-customer-address-form': createCustomerAddressForm,
    'create-customer-contact-form': createCustomerContactForm,
    'customer-detail': customerDetail,
    'customers-list': customersList,
    dashboard: dashboard,
    explorer: explorer,
    filters: filters,
    'generic-list': genericList,
    insights: insights,
    'insights-triage': insightsTriage,
    'line-item-table': lineItemTable,
    notes: notes,
    opportunities: opportunities,
    'preset-date-picker': presetDatePicker,
    'product-details': productDetails,
    quotes: quotes,
    'quotes-orders-actions': quotesOrdersActions,
    'quotes-orders-header': quotesOrdersHeader,
    'quotes-orders-line-actions': quotesOrdersLineActions,
    'quotes-orders-line-items': quotesOrdersLineItems,
    'quotes-orders-list': quotesOrdersList,
    reorders: reorders,
    'sales-draft': salesDraft,
    'sales-history': salesHistory,
    'table-common': tableCommon,
    'table-product-availibity': tableProductAvailibity,
    'table-product-sales-history': tableProductSalesHistory,
    'tapi-integration': tapiIntegration,
    tasks: tasks,
    toasts: toasts,
    'transaction-details': transactionDetails,
    events: events,
    'order-line-status': orderLineStatus,
    'order-status': orderStatus,
    team: team,
};
